import React from "react";

const Grupo6 = ({datos,handleChange,eliminarFila}) => {

    return (

        <div>

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th style={{ width: "40%" }}>Tipo de servicio</th>
                            <th style={{ width: "180px" }}>Cantidad requerida</th>
                            <th style={{ width: "180px" }}>Cantidad activa</th>
                            <th style={{ width: "150px" }}>Indicador</th>
                            <th style={{ width: "80px" }}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>

                                <td colSpan={5} className="text-center">
                                    No hay registros. Presione "Agregar fila" para comenzar.
                                </td>

                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Tipo de servicio"
                                            value={item.tipo_servicio || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "tipo_servicio",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.cantidad_requerida ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "cantidad_requerida",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.cantidad_activa ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "cantidad_activa",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            className="form-control"
                                            value={`${item.indicador_servicio ?? 0}%`}
                                            readOnly
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>
                                            <i className="bi bi-trash"></i>
                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo6;